import { TablePagination } from '@material-ui/core';
import * as React from 'react';
import { useProductChangeHistory } from 'v2/hooks/useproductChangeHistory';

import type { ChangeHistoryFilter } from 'v2/interfaces/productChangeHistory';

import { useStyles } from './styles';
import { ChangeHistoryItem } from '../ChangeHistoryItem';

type ProductData = {
  id: number;
  title: string;
};

type ChangeHistoryContentProps = {
  productData: ProductData;
};

const initialFilter: ChangeHistoryFilter = {
  page: 0,
  perPage: 20,
};

export const ChangeHistoryContent = ({ productData }: ChangeHistoryContentProps) => {
  const [filter, setFilter] = React.useState(initialFilter);

  const changeHistoryQuery = useProductChangeHistory({ productId: productData.id, filter });

  const classes = useStyles();

  const handlePageChange = (event: React.MouseEvent, page: number) => {
    setFilter((filter) => {
      return {
        ...filter,
        page,
      };
    });
  };

  const handlePerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const perPage = Number(event.target.value);
    setFilter((filter) => {
      return {
        ...filter,
        perPage,
      };
    });
  };

  if (changeHistoryQuery.isLoading) return <div>Carregando...</div>;
  if (changeHistoryQuery.isError) return <div>Carregamento falhou, tente novamente mais tarde.</div>;

  return (
    <>
      <div className={classes.scrollableContent}>
        {changeHistoryQuery.data.map((item) => (
          <ChangeHistoryItem key={item.historyCreatedAt} content={item} />
        ))}
      </div>
      <TablePagination
        component='div'
        count={changeHistoryQuery.data.length}
        page={filter.page}
        onPageChange={handlePageChange}
        rowsPerPage={filter.perPage}
        onRowsPerPageChange={handlePerPageChange}
        rowsPerPageOptions={[20, 30, 40]}
      />
    </>
  );
};
